import { baseURL } from "../utilits/config";
import axios from "axios";

export function addTraders(farmerData, callback) {
  const config = {
    method: "post",
    url: baseURL + "/add-farmer",
    headers: {
      "Content-Type": "application/json",
    },
    data: farmerData,
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}

export function getTraders(callback) {
  const config = {
    method: "get",
    url: baseURL + "/add-farmer",
    headers: {},
  };

  axios(config)
    .then((result) => {
      callback(result.data);
    })
    .catch((error) => {
      callback(error);
    });
}

export function getTradersByID(id, callback){
    const config = {
       method : "get",
       url : baseURL + "/get-farmersBy-id?id=" + id,
       headers : {}
    };

    axios(config)
       .then((result) =>{
          callback(result.data);
       })
       .catch((error) =>{
          callback(error);
       })
}
